<section class="details-page__price">
    <h3 
    class="ci-heading-h3-s-bold price__title">
      {{ 'Precio' | translate }}
    </h3>
    <p 
      class="ci-paragraph-p3-regular price__text"
    >
      {{ price() | translate }}
    </p>
</section>